import { render, staticRenderFns } from "./CenterForm.vue?vue&type=template&id=2f48de6f&scoped=true"
import script from "./CenterForm.vue?vue&type=script&lang=js"
export * from "./CenterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f48de6f",
  null
  
)

export default component.exports